import React from "react";
import "./InformationalPages.css";
import useTitle from '../hooks/useTitle';
import "./About.css"; // Reuse the same legal CSS

const Legal = () => {
    useTitle('Legal');

    return (
        <div className="ffls-info-page">
            <div className="login-box ffls-info-panel">
                <h1>Legal Notices & Disclaimers</h1>
                <span className="effective-date">Effective Date: {new Date().toLocaleDateString()}</span>

                <p>
                    The information provided by <strong>FFLs.io</strong> (“we,” “our,” “us”) on our website,
                    mobile applications, and related services (collectively, the “Services”) is for general
                    informational purposes only. By accessing or using our Services, you agree to the following
                    terms and legal notices in their entirety.
                </p>

                <h2>1. No Legal Advice</h2>
                <p>
                    The content, materials, and information available on or through the Services are provided for
                    informational purposes only and do not constitute legal, financial, or professional advice.
                    You should consult qualified professionals before making any decisions based on such information.
                </p>

                <h2>2. Federal Firearms License (FFL) Information</h2>
                <p>
                    FFLS.io provides publicly available Federal Firearms License data and allows licensed dealers to
                    claim and manage their profiles. We make reasonable efforts to ensure accuracy, but we cannot
                    guarantee that all data is current or error-free. You are solely responsible for verifying the
                    authenticity and status of any FFL information before engaging in any transaction.
                </p>

                <h2>3. Compliance with Laws</h2>
                <p>
                    You agree to comply with all applicable federal, state, and local laws, regulations, and
                    ordinances in connection with your use of the Services. You are solely responsible for ensuring
                    your activities on the platform comply with the Gun Control Act (GCA), National Firearms Act
                    (NFA), and any other applicable statutes.
                </p>

                <h2>4. Intellectual Property Rights</h2>
                <p>
                    All content, features, and functionality of the Services, including but not limited to text,
                    graphics, logos, icons, images, software, and databases, are the exclusive property of FFLS.io
                    or its licensors and are protected by copyright, trademark, and other intellectual property
                    laws. You may not copy, reproduce, distribute, or create derivative works without our prior
                    written consent.
                </p>

                <h2>5. Third-Party Links</h2>
                <p>
                    Our Services may contain links to third-party websites or resources. We do not endorse, control,
                    or assume any responsibility for the content, privacy policies, or practices of any third-party
                    sites or services.
                </p>

                <h2>6. Limitation of Liability</h2>
                <p>
                    To the fullest extent permitted by law, FFLS.io, its affiliates, officers, directors, employees,
                    and agents shall not be liable for any direct, indirect, incidental, consequential, special, or
                    punitive damages arising from or related to your use of the Services, even if we have been
                    advised of the possibility of such damages.
                </p>

                <h2>7. Indemnification</h2>
                <p>
                    You agree to defend, indemnify, and hold harmless FFLS.io, its affiliates, and their respective
                    officers, directors, employees, and agents from and against any claims, damages, liabilities,
                    losses, costs, or expenses (including attorneys’ fees) arising out of or relating to your
                    violation of these Legal Notices or your use of the Services.
                </p>

                <h2>8. No Warranty</h2>
                <p>
                    The Services are provided “as is” and “as available” without any warranties of any kind, either
                    express or implied, including but not limited to warranties of merchantability, fitness for a
                    particular purpose, and non-infringement.
                </p>

                <h2>9. Changes to Legal Notices</h2>
                <p>
                    We may update these Legal Notices at any time without prior notice. The updated version will be
                    effective upon posting. Your continued use of the Services constitutes your acceptance of any
                    changes.
                </p>

                <h2>10. Questions About Our Policies</h2>
                <p>
                    If you have questions or concerns regarding our Terms of Use, Privacy Policy, or other published website policies, please contact us at{" "}
                    <a href="mailto:info@ffls.io">info@ffls.io</a>.
                </p>
                <p>FFLS.io does not provide legal advice or legal representation.</p>
            </div>
        </div>
    );
};

export default Legal;